import { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import Parser from 'html-react-parser';
import "./SendANerd.css";

export const SendANerd = ({token}) => {
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  //const [token, setToken] = useState('');
  const [signUpUrl, setSignUpUrl] = useState('');
  const [userId, setUserId] = useState('');
  const [phoneEntered, setPhoneEntered] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const [inputClasses, setInputClasses] = useState(["sendANerdRight"]);
  const [welcomeClasses, setWelcomeClasses] = useState(["sendANerdWelcome", "landingHidden", "landingHiddenVisually"]);
  const [phoneErrorClasses, setPhoneErrorClasses] = useState(["phoneError", "landingHidden"]);
  const [phoneInputSectionClasses, setPhoneInputSectionClasses] = useState(["phoneInputs"]);
  const [emailInputSectionClasses, setEmailInputSectionClasses] = useState(["emailInputs", "landingHidden"]);
  const [sendANerdJoin, setSendANerdJoin] = useState('JOIN FELLOW DROPS:');
  const [sendANerdLurkText, setSendANerdLurkText] = useState('*Free to join. Message and data rates may apply.<br/>Reply STOP to opt-out anytime');

  const onEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const onPhoneChange = (event) => {
    const value = event.target.value;
    const stripped = value.replace(/\D/g, '');

    const l = stripped.length;
    if (l<=3) {
      setPhone(stripped);
    } else if (l > 3 && l < 7) {
      setPhone(stripped.replace(/^(\d{3})(\d+)$/, '($1) $2'));
    } else if (l>=10) {
      setPhone(stripped.replace(/^(\d{3})(\d{3})(\d{4}).*$/, '($1) $2 $3'));
    } else {
      setPhone(stripped.replace(/^(\d{3})(\d{3})(\d+)$/, '($1) $2 $3'));
    }
  };

  const textMeClick = async (event) => {
    event.preventDefault();

    let currentPhone = phone;
    if (currentPhone === '') {
        currentPhone = document.getElementById('topPhone').value;
    }

    const response = await fetch('/phonesignup', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify({
        phone: currentPhone,
        utm_source: searchParams.get('utm_source'),
        utm_content: searchParams.get('utm_content'),
        utm_medium: searchParams.get('utm_medium'),
        utm_campaign: searchParams.get('utm_campaign')
      })
    }).then(response => {
        response.json().then(data => {
            if (data.error) {
                setPhoneErrorClasses(phoneErrorClasses.filter(item => item.indexOf('landingHidden') < 0 ));
                setPhoneError(data.error);
            } else {
                setPhoneErrorClasses(current => [...current, 'landingHidden']);
                setPhoneError('');
                setPhoneInputSectionClasses(['landingHidden']);
                setEmailInputSectionClasses(['emailInputs']);
                setSignUpUrl(data.url);
                setUserId(data.customer_id);
                setInputClasses(current => [...current, 'sendANerdRightBlue']);
                setSendANerdJoin("Step 2: Can we get your email?");
                setSendANerdLurkText("You're in! Now complete your account details for seamless ordering of our super-limited coffees!");
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'location': 'sendANerdInput',
                    //'phone': data.phone,
                    'user_id': data.id,
                    'event': 'phone_number_submission'
                });
            }
        })
    });
  };

  const signUpClick = async (event) => {
    event.preventDefault();
    await fetch('/signupupdateemail', {
      method: "POST",
      headers: {"Content-Type": "application/json", "X-CSRFToken": token},
      body: JSON.stringify({
        id: userId,
        email: email,
      })
    }).then(response => {
        response.json().then(data => {
            if (data.error) {
                setPhoneErrorClasses(phoneErrorClasses.filter(item => item.indexOf('landingHidden') < 0 ));
                setPhoneError(data.error);
                setPhoneInputSectionClasses(['phoneInputs']);
                setEmailInputSectionClasses(['emailInputs', 'landingHidden']);
            } else {
                window.location.href = signUpUrl;
                /*
                setUserId(data.id);
                setPhoneEntered(data.phone);
                setSignUpUrl(data.url);
                setInputClasses(current => [...current, 'landingHidden']);
                setWelcomeClasses(welcomeClasses.filter(item => item.indexOf('landingHidden') < 0 ));
                */
            }
        });
    });
  };

  const letsGoClick = () => {
    window.dataLayer.push({
        'location': 'sendANerdInput',
        //'phone': data.phone,
        'user_id': userId,
        'event': 'signup_click'
    });
    window.location.href = signUpUrl;
  };

  return (
    <div className="sendANerd" >
        <div className="sendANerdLeft" >
            <img alt="Coffee Nerd" className="sendANerdImg" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Phone_Coffee_Images/fellow_drops_animated_desktop.gif"}/>
            <img alt="Coffee Nerd Mobile" className="sendANerdImgMobile" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Photography/Phone_Coffee_Images/fellow_drops_animated_mobile.gif"}/>
        </div>

        <div id="sendANerdWelcome" className={welcomeClasses.join(' ')}>
            <div className="sendANerdWelcomeTop">
                <div className="sendANerdWelcomeTitle">
                  <div className="sendANerdWelcomeTitleText">Welcome to Drops!</div>
                  <img alt="Party" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Various_Illustrations/party.png"}/>
                </div>
                <div className="sendANerdWelcomeText">
                You signed up with <span id="sendANerdPhoneEntered">{phoneEntered}</span>.<br/>Look out for a welcome text now.
                </div>
                <div className="sendANerdWelcomeSubtext">
                Psst... want to get ahead of the curve?<br/>Save a shipping address now for easier purchases.
                </div>
                <div id="sendANerdWelcomeLink" className="sendANerdWelcomeLetsGo" onClick={letsGoClick}>
                     <div className="sendANerdWelcomeLetsGoText">
                     LET'S GO
                     </div>
                </div>
            </div>
            <div className="sendANerdWelcomeBottom">
                <div className="sendANerdWelcomeBottomStickers">
                  <div className="sendANerdWelcomeCheckPhoneSticker">
                    <img alt="Check Your Phone" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/check_your_phone.png"} width="206" height="197"/>
                  </div>
                  <div className="sendANerdWelcomeMugSticker">
                    <img alt="Mug" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/mug_sticker2.png"} width="90" height="90"/>
                  </div>
                </div>
            </div>
        </div>



        <div className={inputClasses.join(' ')} id="sendANerdRight">
            <div className="sendANerdTitle" id="sendANerd" >
            Give a coffee nerd your number
            </div>
            <div id="sendANerdPhoneEntry">
                <div className="sendANerdJoin">
                {Parser(sendANerdJoin)}
                </div>
                    <div className="sendANerdInputs">

                      <div className={phoneInputSectionClasses.join(' ')}>
                        <div className="topLeftInputContainer" id="nerdInput" >
                            <div>
                                <input id="middlePhone" className="topLeftInput" autoComplete="on" inputMode="tel" type="tel" onChange={onPhoneChange} value={phone} placeholder="PHONE NUMBER"/>
                         
                            </div>
                        </div>
                        <div id="middleNext" className="topLeftTextMe" onClick={textMeClick}>
                            <div className="topLeftTextMeText">
                            TEXT ME
                            </div>
                        </div>
                      </div>

                      <div className={emailInputSectionClasses.join(' ')}>
                        <div className="topLeftInputContainer" id="topLeftInput" >
                            <div>
                                <input id="middleEmail" className="topLeftInput" value={email} type="tel" onChange={onEmailChange} onkeypress="{(event) => return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57 && event.target.value.length < 14)) }" placeholder="EMAIL" />
                         
                            </div>
                        </div>
                        <div id="middleSubmit" className="topLeftSignUp" onClick={signUpClick}>
                            <div className="topLeftTextMeText">
                            SIGN UP
                            </div>
                        </div>
                      </div>


                    </div>

                <div id="sendANerdPhoneError" className={phoneErrorClasses.join(' ')}>
                    {Parser(phoneError)}
                </div>

                <div className="sendANerdLurk" >
                {Parser(sendANerdLurkText)}
                </div>
            </div>
        </div>
    </div>


  );
}

